<template>
  <div class="skeleton" role="status" aria-label="Cargando productos">
    <div class="skeleton-grid">
      <div
        v-for="i in count"
        :key="i"
        class="skeleton-card"
        aria-hidden="true"
      >
        <div class="skeleton-media"></div>
        <div class="skeleton-body">
          <div class="skeleton-line skeleton-line--title"></div>
          <div class="skeleton-line skeleton-line--genotype"></div>
          <div class="skeleton-line skeleton-line--footer"></div>
        </div>
      </div>
    </div>

    <!-- Reserva el espacio de los indicadores del carrusel -->
    <div class="skeleton-dots" aria-hidden="true">
      <span class="skeleton-dot"></span>
      <span class="skeleton-dot is-active"></span>
      <span class="skeleton-dot"></span>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
defineProps({
  count: {
    type: Number,
    default: 4
  }
})
</script>

<style scoped>
/* Espeja las medidas reales del RotatingGrid + ProductCard para que la sección
   no cambie de alto al pasar del esqueleto a las tarjetas cargadas. */
.skeleton-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1.5rem;
}

.skeleton-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

/* La imagen de la tarjeta es 1:1: misma proporción reservada */
.skeleton-media {
  aspect-ratio: 1;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: #111;
  flex-shrink: 0;
}

.skeleton-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding: 0.75rem;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-top: 0;
}

.skeleton-line {
  background:
    linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.05) 25%,
      rgba(255, 255, 255, 0.13) 50%,
      rgba(255, 255, 255, 0.05) 75%
    );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.4s linear infinite;
}

.skeleton-line--title { width: 78%; height: 1.1rem; }
.skeleton-line--genotype { width: 60%; height: 0.72rem; }

/* El pie de la tarjeta real mide ~2.75rem (min-height + contenido): se reserva igual */
.skeleton-line--footer {
  width: 48%;
  height: 2.75rem;
  margin-top: auto;
}

/* Indicadores: rectángulo activo + cuadraditos, iguales a los reales */
.skeleton-dots {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 1.75rem;
}

.skeleton-dot {
  width: 4px;
  height: 4px;
  background: rgba(255, 255, 255, 0.28);
}

.skeleton-dot.is-active {
  width: 42px;
  background: rgba(255, 255, 255, 0.16);
}

@keyframes skeleton-shimmer {
  from { background-position: 200% 0; }
  to { background-position: -200% 0; }
}

@media (max-width: 800px) {
  .skeleton-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .skeleton-line {
    animation: none;
  }
}
</style>
